module.exports = __webpack_public_path__ + "img/habitaciones.2a4e61bb.jpeg";